import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { SubregionService } from '../proxy/planning/controllers/subregion.service';

FieldBuilder.setNamespace('Planning');

export const ZONE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Zone.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Zone.Code')
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('subregionId', 'Entity.Subregion', SubregionService)
    .displayFromNested('subregion.name')
    .sortBy('subregion.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const ZONE_CONFIG = {
  entityName: 'Zone',
  localizationKey: 'Planning::Entity.Zone',
  permission: 'PlanningLocation.Zones',
  fields: ZONE_FIELDS,
  children: [],
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
